// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3CtEV","buttons":"SendReceipts_buttons__2dfcz","email":"SendReceipts_email__3uJ_W","bookApptTitle":"SendReceipts_bookApptTitle__1TUlm"};